import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed6f7928"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-screen bg-primary-50" }
const _hoisted_2 = { class: "container mx-auto px-4 py-8 max-w-4xl" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-display-sm font-heading font-bold text-primary-800 mb-6" }, " Association Covenants ", -1))
const _hoisted_4 = { class: "bg-white rounded-xl border border-primary-200 shadow-soft p-4 mb-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-primary-700 mb-2" }, " Search Covenants ", -1))
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-primary-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
  })
], -1))
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-primary-500 mt-2"
}
const _hoisted_9 = { class: "bg-white rounded-xl border border-primary-200 shadow-soft p-6 prose prose-slate max-w-none" }
const _hoisted_10 = ["innerHTML"]

import { ref, computed } from "vue";
import { HoodApi } from "@/services/HoodApi";
import { highlightSearchTerm } from "@/utils/sanitize";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const covenants = ref();
const searchQuery = ref("");
const covenantData = computed(() => covenants.value);
const mainText = ref("");

const setup = async () => {
  covenants.value = await HoodApi.get_covenants();
  mainText.value = covenants.value[0].body;
};

const search_and_highlight = () => {
  // Use sanitized highlight function to prevent XSS
  return highlightSearchTerm(mainText.value, searchQuery.value);
};

setup();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Search for keywords...",
            class: "w-full px-4 py-3 pl-10 text-primary-800 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event))
          }, null, 512), [
            [_vModelText, searchQuery.value]
          ]),
          _hoisted_7
        ]),
        (searchQuery.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Highlighting results for \"" + _toDisplayString(searchQuery.value) + "\" ", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: "covenant-content",
          innerHTML: search_and_highlight()
        }, null, 8, _hoisted_10)
      ])
    ])
  ]))
}
}

})